// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Featured__wrapper___31l1r","title":"Featured__title___KZhMb typography__title___3pJfO","featured":"Featured__featured___3Ghz8","grid-item":"Featured__grid-item___3l_PM","preceived-item":"Featured__preceived-item___3QT-T","image-wrapper":"Featured__image-wrapper___1AxI-","info":"Featured__info___131Gg","count":"Featured__count___1NWnw"};


//////////////////
// WEBPACK FOOTER
// ./application/js/components/Featured.css
// module id = 518
// module chunks = 0